(function () {
  var visibleClass = 'back-to-top-button--visible';
  var button = document.querySelector('[data-back-to-top-button]');

  if (!button) return;

  window.addEventListener('scroll', function () {
    if (window.scrollY > 500) {
      button.classList.add(visibleClass);
    } else {
      button.classList.remove(visibleClass);
    }
  });

  button.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
